// 寄件提成报表
import http from '@core/api/http'
import { Res } from '@core/api/type'

import {
  getShippingCommissionListResp,
  QueryStatisticsModel,
  QueryStatisticsRespModel
} from '@/model/shippingCommission/main'

export const queryStatistics = (
  data: QueryStatisticsModel
): Res<QueryStatisticsRespModel> => {
  return http.request({
    url: '/app/brokerage/queryStatistics',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

export const queryList = (
  data: QueryStatisticsModel
): Res<getShippingCommissionListResp[]> => {
  return http.request({
    url: '/app/brokerage/queryList',
    method: 'post',
    data,
    loadingShow: '0'
  })
}
